import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_map-marker",
  "use": "icon_map-marker-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon_map-marker\"><path d=\"M11.443 22.902C4.81 13.286 3.58 12.3 3.58 8.765a8.765 8.765 0 1117.53 0c0 3.534-1.23 4.521-7.864 14.137a1.096 1.096 0 01-1.802 0zm.901-10.485a3.652 3.652 0 100-7.304 3.652 3.652 0 000 7.304z\" fill=\"#A7B1C0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol